module.exports = __webpack_public_path__ + "ug.da14426dfec424f67c13.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ug.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ug.svg
// module chunks = styles